import { Suspense } from "react";

import { createBrowserRouter, Navigate, RouterProvider } from "@libs/router";

import { DQDashboard, Auth, AuthGuard, GuestRoute } from "../features";

export const AppRoutes = () => {
  const router = createBrowserRouter([
    {
      path: "/auth",
      element: (
        <GuestRoute>
          <Auth />
        </GuestRoute>
      ),
    },
    {
      path: "/",
      element: <AuthGuard />,
      children: [
        {
          index: true,
          element: <Navigate to="/dashboard" replace />,
        },
        {
          path: "dashboard",
          element: <DQDashboard />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/dashboard" replace />,
    },
  ]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <RouterProvider router={router} />
    </Suspense>
  );
};
